export const SUCCESS = {
  BASE: "Success",
  FORGOT_PASSWORD: "An email will be sent to the above address with a link to set your new password",
  CHANGE_PASSWORD: "Successfully change password",
  SIGN_OUT: "Good bye {USER_EMAIL}",
  SIGN_UP: "Your account has been created",
  WELCOME: "Welcome {USER_EMAIL}",
  VERIFY_CODE: "Correct verify code",
  REVERT: "Revert",

  LOCATION_CREATE: "New location has been created",
  LOCATION_CREATE_WORKING_TIME: "Add working time for location succeed",
  LOCATION_DELETE: "Location has been deleted",
  LOCATION_UPDATE: "Location has been updated",

  MAXIMUN_SERVICE_CREATE: "Maximum 3 services. You can change it in the setting later!",
  MAXIMUN_STAFF_CREATE: "Maximum 5 staffs. You can change it in the setting later!",

  APPOINTMENT_CREATE: "New appointment has been created",
  APPOINTMENT_UPDATE: "Appointment has been updated",
  APPOINTMENT_DELETE: "Appointment has been deleted",
  APPOINTMENT_GROUP_UPDATE: "Appointment group has been updated",
  APPOINTMENT_RESCHEDULED: "Appointment successfully rescheduled!",
  APPOINTMENT_DIDNT_RESCHEDULED: "Appointment did not rescheduled!",
  RESIZE_APPOINTMENT: "Resize appointment successfully",
};
